import React from 'react';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useUpsertServiceMutation } from '../../../../services/ConfigurationService';

export function AddServiceDialog({ defaultCenterId, onSuccess }: { defaultCenterId: string; onSuccess?: () => void }) {
  const [open, setOpen] = React.useState(false);
  const [code, setCode] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [upsertService, { isLoading }] = useUpsertServiceMutation();

  const handleSave = async () => {
    if (!code) return;
    const id = `${defaultCenterId}-${code}`;
    await upsertService({ id, centerId: defaultCenterId, code, description });
    setOpen(false);
    setCode('');
    setDescription('');
    if (onSuccess) onSuccess();
  };

  return (
    <React.Fragment>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Add Service
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add Service</DialogTitle>
        <DialogContent>
          <TextField
            label="Code"
            value={code}
            onChange={e => setCode(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Description"
            value={description}
            onChange={e => setDescription(e.target.value)}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} variant="outlined">Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary" disabled={isLoading}>Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
